import React from 'react';
import { createPortal } from 'react-dom';
import { backdropCloseHandlers } from '../../../../utils/backdropClose';
import './Launch3DViewerModal.css';

const Launch3DViewerModal = ({ projectId, projectName, isOpen, onClose, onLaunchSuccess }) => {
  const handleYes = () => {
    // Close the modal immediately
    onClose();

    // Trigger the launch success callback which will start the loading bar
    if (onLaunchSuccess) {
      onLaunchSuccess();
    }
  };

  const handleNo = () => {
    onClose();
  };

  if (!isOpen) return null;

  return typeof document !== 'undefined' && createPortal(
    <div className="launch-3d-viewer-modal-overlay" {...backdropCloseHandlers(handleNo)}>
      <div className="launch-3d-viewer-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="launch-3d-viewer-modal-header">
          <h3>Launch 3D Viewer?</h3>
        </div>
        
        <div className="launch-3d-viewer-modal-body">
          <p>
            The 3D viewer is currently stopped. Would you like to launch it now?
          </p>
          <p className="launch-3d-viewer-modal-warning">
            <i className="fas fa-clock"></i>
            This process can take a few minutes.
          </p>
          
        </div>

        <div className="launch-3d-viewer-modal-footer">
          <button
            className="launch-3d-viewer-modal-btn launch-3d-viewer-modal-btn-no"
            onClick={handleNo}
          >
            No
          </button>
          <button
            className="launch-3d-viewer-modal-btn launch-3d-viewer-modal-btn-yes"
            onClick={handleYes}
          >
            Yes
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Launch3DViewerModal;

